export default __webpack_public_path__ + "static/media/43k.d04581e4.yaml";